import { createContext } from 'react';

const apiMethodContext = createContext();

export default apiMethodContext;
